import { Injectable } from '@angular/core';
import { CommonService } from './common.service';
import { appConfig } from '../app.config';
import { Observable } from 'rxjs';
import { group,groups,companyIdentifier,companyIdentifiers, companies, company, groupAssignments, groupAssignment, groupIdentifier, groupIdentifiers, businessEntities, businessEntity, businessEntityIdentifier, businessEntityIdentifiers, bvdInterface, CompanyIdentifierkeys, CompanyNames, CompanyName, CompanyStatus, CompanyStatuses, siteAssignments, siteAssignment, groupTypes, groupType, groupIdentifierKeys, groupIdentifierKey, approvalScopes, approvalScope, groupApprovals, groupApproval, companyNameTypes, companyNameType, companyApprovals, approvalStatus, approvalStatuses, companyApproval, payingCompany, payingCompanies, businessEntityIdentifierTypes, businessEntityIdentifierType, groupAssignmentTypes, groupAssignmentType } from './models/group';
@Injectable({
  providedIn: 'root'
})
export class SupplierService {
  apiUrl: string='';
  constructor(private apiService: CommonService) {
    this.apiUrl=appConfig.SupplierserviceUrl;
   }

   //get groups
   get(url: string):Observable<any> {
    return this.apiService.getServiceCall(`${this.apiUrl}/getSupplierApi`, url) as Observable<any>;
   }
  getGroups(url: string):Observable<groups> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-groups`, url) as Observable<groups>;
    return this.apiService.response(data,groups,'groups') as Observable<groups>;
   }

   getGroupById(url: string):Observable<group> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-groups`, url) as Observable<group>;
    return this.apiService.response(data,group,'groups') as Observable<group>;
   }

   getCompanyNameTypes(url: string):Observable<companyNameTypes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-name-types`, url) as Observable<companyNameTypes>;
    return this.apiService.response(data,companyNameTypes,'company-name-types') as Observable<companyNameTypes>;
   }

   getCompanyNameTypesById(url: string):Observable<companyNameType> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-name-types`, url) as Observable<companyNameType>;
    return this.apiService.response(data,companyNameType,'company-name-types') as Observable<companyNameType>;
   }

   createGroups(url: string, data):Observable<group> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-groups`, url,data) as Observable<group>;
   }

   UpdateGroups(url: string, data):Observable<group> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-groups`, url, data) as Observable<group>;
   }

   getCompanyIdentifiers(url: string):Observable<companyIdentifiers> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-identifiers`, url) as Observable<companyIdentifiers>;
    return this.apiService.response(data,companyIdentifiers,'company-identifiers') as Observable<companyIdentifiers>;
   }
   createCompanyIdentifiers(url: string, data):Observable<companyIdentifier> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-company-identifiers`, url,data) as Observable<companyIdentifier>;
   }
   updateCompanyIdentifiers(url: string, data):Observable<companyIdentifier> {
    return this.apiService.postServiceCall(`${this.apiUrl}/update-company-identifiers`, url,data) as Observable<companyIdentifier>;
   }
   getCompanies(url: string):Observable<companies> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-companies`, url) as Observable<companies>;
    return this.apiService.response(data,companies,'companies') as Observable<companies>;
   }
   createCompany(url: string, data):Observable<companies> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-companies`, url,data) as Observable<companies>;
   }
   UpdateCompany(url: string, data):Observable<companies> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-companies`, url,data) as Observable<companies>;
   }
   getCompanyById(url: string):Observable<company> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-companies`, url) as Observable<company>;
    return this.apiService.response(data,company,'companies') as Observable<company>;
   }
   getGroupAssignments(url: string):Observable<groupAssignments> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-assignments`, url) as Observable<groupAssignments>;
    return this.apiService.response(data,groupAssignments,'group-assignments') as Observable<groupAssignments>;
   }
   getGroupAssignmentById(url: string):Observable<groupAssignment> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-assignments`, url) as Observable<groupAssignment>;
    return this.apiService.response(data,groupAssignment,'group-assignments') as Observable<groupAssignment>;
   }
   CreateGroupAssignment(url: string, data):Observable<groupAssignment> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-group-assignments`, url,data) as Observable<groupAssignment>;
   }
   updateGroupAssignment(url: string, data):Observable<groupAssignment> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-group-assignments`, url,data) as Observable<groupAssignment>;
   }
   getGroupIdentifiers(url: string):Observable<groupIdentifiers> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-identifiers`, url) as Observable<groupIdentifiers>;
    return this.apiService.response(data,groupIdentifiers,'group-identifiers') as Observable<groupIdentifiers>;
   }
   CreateGroupIdentifiers(url: string, data):Observable<groupIdentifier> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-group-identifiers`, url,data) as Observable<groupIdentifier>;
   }
   updateGroupIdentifiers(url: string, data):Observable<groupIdentifier> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-group-identifiers`, url,data) as Observable<groupIdentifier>;
   }
   DeleteGroupIdentifiers(url: string):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-group-identifiers`, url) as Observable<any>;
   }
   getBusinessEntities(url: string):Observable<businessEntities> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-business-entities`, url) as Observable<businessEntities>;
    return this.apiService.response(data,businessEntities,'business-entities') as Observable<businessEntities>;
   }
   getBusinessEntityById(url: string):Observable<businessEntity> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-business-entities`, url) as Observable<businessEntity>;
    return this.apiService.response(data,businessEntity,'business-entities') as Observable<businessEntity>;
   }
   CreateBusinessEntities(url: string, data):Observable<businessEntity> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-business-entities`, url,data) as Observable<businessEntity>;
   }
   updateBusinessEntities(url: string, data):Observable<businessEntity> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-business-entities`, url,data) as Observable<businessEntity>;
   }
   deleteBusinessEntities(url: string):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-business-entities`, url) as Observable<any>;
   }
   getBusinessEntityIdentifiers(url: string):Observable<businessEntityIdentifiers> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-business-entity-identifiers`, url) as Observable<businessEntityIdentifiers>;
    return this.apiService.response(data,businessEntityIdentifiers,'business-entity-identifiers') as Observable<businessEntityIdentifiers>;
   }
   getBusinessEntityIdentifierById(url: string):Observable<businessEntityIdentifier> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-business-entity-identifiers`, url) as Observable<businessEntityIdentifier>;
    return this.apiService.response(data,businessEntityIdentifier,'business-entity-identifiers') as Observable<businessEntityIdentifier>;
   }
   CreateBusinessEntityIdentifiers(url: string, data):Observable<businessEntityIdentifier> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-business-entity-identifiers`, url,data) as Observable<businessEntityIdentifier>;
   }
   updateBusinessEntityIdentifiers(url: string, data):Observable<businessEntityIdentifier> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-business-entity-identifiers`, url,data) as Observable<businessEntityIdentifier>;
   }
   deleteBusinessEntityIdentifiers(url: string):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-business-entity-identifiers`, url) as Observable<any>;
   }
   createBvdInterface(url: string, data):Observable<bvdInterface> {
    return this.apiService.postServiceCall(`${this.apiUrl}/bvd-interface`, url,data) as Observable<bvdInterface>;
   }
   getCompanyIdentifierKeys(url: string):Observable<CompanyIdentifierkeys> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-identifier-keys`, url) as Observable<CompanyIdentifierkeys>;
    return this.apiService.response(data,CompanyIdentifierkeys,'company-identifier-keys') as Observable<CompanyIdentifierkeys>;
   }
  //  getCompanyIdentifierKeys(url:string):Observable<CompanyIdentifierkeys> {
  //   const cachedResponse = this.companyIdentifierKeysCache.get(url);
  //   if (cachedResponse) {
  //     return cachedResponse;
  //   }

  //   const data = this.apiService.getServiceCall(this.apiUrl + '/get-company-identifier-keys', url) as Observable<CompanyIdentifierkeys>;
  //   const response = this.apiService.response(data,CompanyIdentifierkeys,'company-identifier-keys').pipe(
  //     shareReplay(1),
  //     catchError(error => {
  //       this.companyIdentifierKeysCache.delete(url);
  //       return throwError(() => error);
  //     })
  //   ) as Observable<CompanyIdentifierkeys>;

  //   this.companyIdentifierKeysCache.set(url, response);
  //   return response;
  //  }
   getCompanyNames(url: string):Observable<CompanyNames> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-names`, url) as Observable<CompanyNames>;
    return this.apiService.response(data,CompanyNames,'company-names') as Observable<CompanyNames>;
   }
   CreateCompanyNames(url: string, data):Observable<CompanyName> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-company-names`, url,data) as Observable<CompanyName>;
   }
   updateCompanyNames(url: string, data):Observable<CompanyName> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-company-names`, url,data) as Observable<CompanyName>;
   }
   deleteCompanyName(url: string):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-company-names`, url) as Observable<any>;
   }
   getCompanySatus(url: string):Observable<CompanyStatuses> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-status`, url) as Observable<CompanyStatuses>;
    return this.apiService.response(data,CompanyStatuses,'company-status') as Observable<CompanyStatuses>;
   }
   getSiteAssignments(url: string):Observable<siteAssignments> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-site-assignments`, url) as Observable<siteAssignments>;
    return this.apiService.response(data,siteAssignments,'site-assignments') as Observable<siteAssignments>;
   }
   CreateSiteAssignments(url: string, data):Observable<siteAssignment> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-site-assignments`, url,data) as Observable<siteAssignment>;
   }
   updateSiteAssignments(url: string, data):Observable<siteAssignment> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-site-assignments`, url,data) as Observable<siteAssignment>;
   }
   deleteSiteAssignments(url: string):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-site-assignments`, url) as Observable<any>;
   }
   getGroupTypes(url: string):Observable<groupTypes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-types`, url) as Observable<groupTypes>;
    return this.apiService.response(data,groupTypes,'group-types') as Observable<groupTypes>;
   }

   getGroupTypesById(url: string):Observable<groupType> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-types`, url) as Observable<groupType>;
    return this.apiService.response(data,groupType,'group-types') as Observable<groupType>;
   }
   getGroupIdentifierKeys(url: string):Observable<groupIdentifierKeys> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-identifier-keys`, url) as Observable<groupIdentifierKeys>;
    return this.apiService.response(data,groupIdentifierKeys,'group-identifier-keys') as Observable<groupIdentifierKeys>;
   }

   getGroupIdentifierKeysById(url: string):Observable<groupIdentifierKey> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-identifier-keys`, url) as Observable<groupIdentifierKey>;
    return this.apiService.response(data,groupIdentifierKey,'group-identifier-keys') as Observable<groupIdentifierKey>;
   }

   getApprovalScopes(url: string):Observable<approvalScopes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-approval-scopes`, url) as Observable<approvalScopes>;
    return this.apiService.response(data,approvalScopes,'approval-scopes') as Observable<approvalScopes>;
   }

   getApprovalScopesById(url: string):Observable<approvalScope> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-approval-scopes`, url) as Observable<approvalScope>;
    return this.apiService.response(data,approvalScope,'approval-scopes') as Observable<approvalScope>;
   }

   getGroupApprovals(url: string):Observable<groupApprovals> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-approvals`, url) as Observable<groupApprovals>;
    return this.apiService.response(data,groupApprovals,'group-approvals') as Observable<groupApprovals>;
   }
   getGroupApprovalsById(url: string):Observable<groupApproval> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-approvals`, url) as Observable<groupApproval>;
    return this.apiService.response(data,groupApproval,'group-approvals') as Observable<groupApproval>;
   }
   CreateGroupApprovals(url: string, data):Observable<groupApproval> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-group-approvals`, url,data) as Observable<groupApproval>;
   }
   UpdateGroupApprovals(url: string, data):Observable<groupApproval> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-group-approvals`, url,data) as Observable<groupApproval>;
   }
   getCompanyApprovals(url: string):Observable<companyApprovals> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-approvals`, url) as Observable<companyApprovals>;
    return this.apiService.response(data,companyApprovals,'company-approvals') as Observable<companyApprovals>;
   }
   getCompanyApprovalsbyId(url: string):Observable<companyApproval> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-company-approvals`, url) as Observable<companyApproval>;
    return this.apiService.response(data,companyApproval,'company-approvals') as Observable<companyApproval>;
   }
   createCompanyApprovals(url: string, data):Observable<companyApproval> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-company-approvals`, url,data) as Observable<companyApproval>;
   }
   updateCompanyApprovals(url: string, data):Observable<companyApproval> {
    return this.apiService.UpdateServiceCall(`${this.apiUrl}/update-company-approvals`, url,data) as Observable<companyApproval>;
   }
   deleteCompanyApprovals(url: string):Observable<any> {
    return this.apiService.deleteServiceCall(`${this.apiUrl}/delete-company-approvals`, url) as Observable<any>;
   }
   getApprovalStatus(url: string):Observable<approvalStatuses> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-approval-status`, url) as Observable<approvalStatuses>;
    return this.apiService.response(data,approvalStatuses,'approval-status') as Observable<approvalStatuses>;
   }
   getApprovalStatusbyId(url: string):Observable<approvalStatus> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-approval-status`, url) as Observable<approvalStatus>;
    return this.apiService.response(data,approvalStatus,'approval-status') as Observable<approvalStatus>;
   }
   getPayingCompany(url: string):Observable<payingCompanies> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-paying-company`, url) as Observable<payingCompanies>;
    return this.apiService.response(data,payingCompanies,'paying-company') as Observable<payingCompanies>;
   }
   getPayingCompanybyId(url: string):Observable<payingCompany> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-paying-company`, url) as Observable<payingCompany>;
    return this.apiService.response(data,payingCompany,'paying-company') as Observable<payingCompany>;
   }
   //business-entity-identifier-types
   getBuinessEntityIdentifierTypes(url: string):Observable<businessEntityIdentifierTypes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-business-entity-identifier-types`, url) as Observable<businessEntityIdentifierTypes>;
    return this.apiService.response(data,businessEntityIdentifierTypes,'business-entity-identifier-types') as Observable<businessEntityIdentifierTypes>;
   }
   createBuinessEntityIdentifierTypes(url: string, data):Observable<businessEntityIdentifierType> {
    return this.apiService.postServiceCall(`${this.apiUrl}/create-business-entity-identifier-types`, url,data) as Observable<businessEntityIdentifierType>;
   }

   getGroupAssignmentTypes(url: string):Observable<groupAssignmentTypes> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-assignment-types`, url) as Observable<groupAssignmentTypes>;
    return this.apiService.response(data,groupAssignmentTypes,'group-assignment-types') as Observable<groupAssignmentTypes>;
   }

   getGroupAssignmentTypesById(url: string):Observable<groupAssignmentType> {
    let data = this.apiService.getServiceCall(`${this.apiUrl}/get-group-assignment-types`, url) as Observable<groupAssignmentType>;
    return this.apiService.response(data,groupAssignmentType,'group-assignment-types') as Observable<groupAssignmentType>;
   }

   // Vendor info API for ALCOR status reports
   getVendorInfo(url: string): Observable<any> {
    return this.apiService.getServiceCall(`${appConfig.vendorUrl}/getVendorApi`, url) as Observable<any>;
   }

   CreateVender(url: string, data):Observable<any> {
    return this.apiService.postServiceCall(`${appConfig.vendorUrl}/postVendorApi`, url,data) as Observable<any>;  
   }
}

